export function buildArtworkAlt(title?: string) {
  const safeTitle = title?.trim() || 'custom pet portrait'
  return `Hand-painted oil portrait titled “${safeTitle}” — custom pet artwork from your photos`
}

export function buildProductAlt(title?: string) {
  const safeTitle = title?.trim() || 'custom pet portrait commission'
  return `Custom pet portrait product ${safeTitle} — hand-painted animal artwork in oil`
}

export function buildBlogImageAlt(title?: string) {
  const safeTitle = title?.trim() || 'pet portrait story'
  return `Studio story illustration for “${safeTitle}” — behind-the-scenes custom pet portrait painting`
}

export function buildArtistPortraitAlt(context?: string) {
  const safeContext = context?.trim() || 'the artist in her studio'
  return `Portrait of Daria Chizh in the studio — creator of hand-painted pet portraits (${safeContext})`
}

export function buildReferenceAlt(label: string) {
  return `Client reference photo for ${label}`
}

export function buildGenericPetAlt(subject: string) {
  return `Hand-painted oil painting of ${subject} — realistic custom pet portrait`
}
